export const RESOLVER_PROPS = {
    dependencies: {},
    units: {},
    datamodelTransform: {},
    layerConfig: {},
    matrixLayers: {},
    colCells: {},
    rowCells: {},
    rowMatrix: {},
    columnMatrix: {},
    valueMatrix: {},
    encoder: {},
    valueParser: {},
    data: {},
    transformedData: {},
    store: {}
};
